// extracted by mini-css-extract-plugin
export default {"Theme":"📚19-10-2rI2oH"};